//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class RepertoireSearchOptions extends ItemBase {
    SearchText: string | null = null;
    AvailableToStudentIDs: string[] = [];
    TeacherID: string | null = null;
    ItemID: string | null = null;
    Active: boolean | null = null;
    Instruments: string[] = [];
    Genre: string[] = [];

    constructor(initializer?: Partial<RepertoireSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireSearchOptions";
}
